import moment from 'moment-timezone';
import {
  PROJECT_BUSINESS_UNITS_REQUEST,
  PROJECT_BUSINESS_UNIT_FAILURE,
  PROJECT_BUSINESS_UNIT_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function projectBusinessUnitsRequest() {
  return {
    type: PROJECT_BUSINESS_UNITS_REQUEST,
  };
}

function projectBusinessUnitsSuccess(data, token = null) {
  return {
    type: PROJECT_BUSINESS_UNIT_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function projectBusinessUnitsError(message) {
  return {
    type: PROJECT_BUSINESS_UNIT_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchProjectBusinessUnits(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(projectBusinessUnitsRequest());
    if (!fresh) {
      let projectBusinessUnitsData = {};
      try {
        projectBusinessUnitsData = JSON.parse(getItem(`${config.get('appName')}.projectBusinessUnits`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !projectBusinessUnitsData.data ||
        config.get('version') !== projectBusinessUnitsData.version ||
        moment().isAfter(moment(projectBusinessUnitsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectBusinessUnitsSuccess(projectBusinessUnitsData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/projects/company_branches/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.projectBusinessUnits`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(projectBusinessUnitsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, projectBusinessUnitsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/projectBusinessUnits.js